export default pageNavigation => {
    // console.log('pageNavigation');

    const pageNavigationItems = pageNavigation.querySelectorAll('.page-navigation-item');
    const pageNavigationButtons = pageNavigation.querySelectorAll('.page-navigation-item button');
    const underline = pageNavigation.querySelector('.underline');

    function moveUnderline(target) {
        const active = target !== null ? target : pageNavigation.querySelector('.page-navigation-item.active');

        underline.style.width = `${active.offsetWidth}px`;
        underline.style.left = `${active.offsetLeft}px`;
    }

    pageNavigationItems.forEach(pageNavigationItem => {
        pageNavigationItem.addEventListener('mouseenter', event => moveUnderline(event.target));
        pageNavigationItem.addEventListener('mouseleave', () => moveUnderline(null));

        if (pageNavigation.classList.contains('filters')) {
            pageNavigationItem.querySelector('button').addEventListener('click', event => moveUnderline(event.target.parentNode));
        }
    });

    if (pageNavigation.classList.contains('filters')) {
        pageNavigationButtons.forEach(pageNavigationButton => {
            pageNavigationButton.addEventListener('click', () => {
                pageNavigationButtons.forEach(btn => btn.parentNode.classList.remove('active'));
                pageNavigationButton.parentNode.classList.add('active');
            });
        });
    }

    moveUnderline(null);
};
